import { Contract } from './contracts.service';

/**
 * Is it an Individual Commit contract?
 */
export function isIndividualCommit(contract: Contract): boolean {
  return contract && contract.isGroupRfp && contract.isIndividualCommitment;
}

export default class ComplianceService {
  static $inject = ['$http'];

  baseUrl = '/aptitude/api/compliance/';

  constructor(private $http) {
    'ngInject';
  }

  getCompliance(contractId: number, config?: any): ng.IPromise<Contract> {
    let shouldCache = config && 'cache' in config ? config.cache : true; // default to true if not set

    return this.$http.get(`${this.baseUrl}${contractId}`, {
      cache: shouldCache
    });
  }
}
